import { Column, Heading, url, useFlipperQuery } from "lcm-iot-commons";
import { Link } from "react-router-dom-v5-compat";

export default function NavigationLegalPages() {
  const { data: flipper } = useFlipperQuery();
  const showTermsVersion2025 = flipper?.showTermsVersion2025;

  return (
    <Column md={3}>
      <Heading level={4} title="Legal" />
      <nav className="legal-nav" data-testid="legal-navigation">
        <ul>
          {showTermsVersion2025 && (
            <li>
              <Link to={url("/legal/master-service-agreement")}>
                Master Service Agreement (&quot;Agreement&quot;)
              </Link>
            </li>
          )}

          {showTermsVersion2025 ? null : (
            <li>
              <Link to={url("/legal/terms-of-service")}>Terms of Service</Link>
            </li>
          )}

          <li>
            <Link to={url("/legal/service-level-agreement")}>
              Service Level Agreement
            </Link>
          </li>

          {showTermsVersion2025 ? null : (
            <li>
              <Link to={url("/legal/api-terms")}>API Terms</Link>
            </li>
          )}

          <li>
            <Link to={url("/legal/privacy-policy")}>Privacy Policy</Link>
          </li>
          <li>
            <Link to={url("/legal/security-policy")}>Security Policy</Link>
          </li>

          {showTermsVersion2025 && (
            <>
              <li>
                <Link to={url("/legal/acceptable-use-policy")}>
                  Acceptable Use Policy
                </Link>
              </li>
              <li>
                <Link to={url("/legal/data-localization-policy")}>
                  Data Localization Policy
                </Link>
              </li>
              <li>
                <Link to={url("/legal/definition-netilion-connect")}>
                  Definition of Service: Netilion Connect
                </Link>
              </li>
              <li>
                <Link to={url("/legal/definition-netilion-one")}>
                  Definition of Service: Netilion One
                </Link>
              </li>
              <li>
                <Link to={url("/legal/definition-netilion-process-water")}>
                  Definition of Service: Process Water
                </Link>
              </li>
            </>
          )}

          {showTermsVersion2025 ? null : (
            <li>
              <Link to={url("/legal/definition-netilion-water")}>
                Definition of Service: Netilion Water
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </Column>
  );
}
